module.exports = __webpack_public_path__ + "media/icons/cuk_phone@3x-63b923ad.svg";